import { ReactNode } from "react";

export const OptionalContainer: React.FC<{ show: boolean, children: ReactNode; className?: string }> = ({ show, children, className }) => {
    return show ? <div className={className}>{children}</div> : children;
}